<template>
    <div class="feed-back-container">
        <feedback-header :title="title" />
        <div class="option-container clearfix">
            <router-link :to="{ name: 'feedbackSuggest' }" class="suggest"
                ><img src="@/assets/images/feedback/suggestion.png" class="suggest-img" /><span>我有建议</span></router-link
            >
            <router-link :to="{ name: 'feedbackProblem' }" class="problem"
                ><img src="@/assets/images/feedback/question.png" class="problem-img" /><span>遇到问题</span></router-link
            >
        </div>
        <div class="hot-issues-container">
            <div v-show="!showDetail">
                <span class="issue-title">热门问题</span>
                <p class="customer" @click="onlineConsult">
                    <img src="@/assets/images/feedback/CS.png" class="cs-img" />
                    <span>在线客服</span>
                </p>
            </div>
            <ul v-show="!showDetail" class="issue-contents">
                <li v-for="(item, index) in qaData.QAContent" :key="index" class="issue-item" @click.prevent="showIssueDetail(item, index)">
                    <div>
                        <p>{{ item.title }}</p>
                        <icon name="right"></icon>
                    </div>
                </li>
            </ul>
            <div v-show="showDetail" class="issue-detail">
                <p class="detail-title" v-html="qaData.QAContent[qaIndex].title"></p>
                <p class="go-back" @click="backToIssues"><icon name="to-left"></icon></p>
                <p v-for="(item, index) in qaData.QAContent[qaIndex].content" :key="index" class="detail-content">{{ item }}</p>
                <div class="link-service">若以上信息没有解决您的问题，您可以使用<span @click="onlineConsult">在线客服</span>为您解决。</div>
                <div class="evaluate">
                    <p class="disagree" :class="{ active: isChecked === 0 }" @click="selectEvaluate(0)">
                        <img :src="isChecked !== 0 ? imgUrl[0].notSelect : imgUrl[0].selected" />
                        <span>没有用</span>
                    </p>
                    <p class="agree" :class="{ active: isChecked === 1 }" @click="selectEvaluate(1)">
                        <img :src="isChecked !== 1 ? imgUrl[1].notSelect : imgUrl[1].selected" />
                        <span>很有用</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FeedbackHeader from './feedback-header'
import qaData from './qaConfig.json'
import getOnlineService from '@/mixins/onlineService/index'

export default {
    components: {
        FeedbackHeader
    },
    data() {
        return {
            title: this._ll('意见反馈'),
            qaData,
            showDetail: false,
            qaIndex: 0,
            isChecked: -1,
            imgUrl: [
                { notSelect: require('@/assets/images/feedback/sad.png'), selected: require('@/assets/images/feedback/sad_r.png') },
                { notSelect: require('@/assets/images/feedback/happy.png'), selected: require('@/assets/images/feedback/happy_r.png') }
            ],
            csUrl: '', // 在线客服地址
            agreeEventName: '', // 满意埋点事件名
            agreeEventId: '', // 满意埋点事件ID
            disagreeEventName: '', // 不满意埋点事件名
            disagreeEventId: '' // 不满意埋点事件ID
        }
    },
    methods: {
        async onlineConsult() {
            this.csUrl = await getOnlineService()
            window.open(this.csUrl, '_blank')
        },
        // 显示问题详情
        showIssueDetail(item, index) {
            this.showDetail = true
            this.qaIndex = index
            this.agreeEventName = item.gather.agree.name
            this.agreeEventId = item.gather.agree.id
            this.disagreeEventName = item.gather.disagree.name
            this.disagreeEventId = item.gather.disagree.id
        },
        // 返回反馈首页
        backToIssues() {
            this.showDetail = false
            this.isChecked = -1
        },
        // 选择是否有用
        selectEvaluate(index) {
            if (this.isChecked === 0 || this.isChecked === 1) {
                return
            }
            this.isChecked = index
        }
    }
}
</script>

<style lang="scss" scoped>
.feed-back-container {
    padding: 0 0.2rem 0.4rem;
}
.option-container {
    position: relative;
    text-align: center;
    a {
        display: inline-block;
        width: 43%;
        span {
            display: block;
            font-size: 0.28rem;
        }
        padding: 0.3rem 0.2rem;
        margin: 0 0.2rem;
        box-shadow: 0.02rem 0.1rem 0.4rem $gray-light;
    }
}
.hot-issues-container {
    margin-top: 0.5rem;
    padding: 0 0.32rem;
    .issue-title {
        font-size: 0.34rem;
    }
    .customer {
        position: absolute;
        right: 0.6rem;
        width: 1.56rem;
        height: 0.44rem;
        background: $bg-color;
        border-radius: 0.22rem;
        font-size: 0.16rem;
        .cs-img {
            width: 0.3rem;
            margin: 0.1rem;
        }
        span {
            position: absolute;
            top: 0.08rem;
            font-size: 0.22rem;
        }
    }
    .issue-item {
        padding: 0.3rem 0.6rem 0.3rem 0;
        position: relative;
        border-bottom: 1px solid $gray-light;
        p {
            font-size: 0.28rem;
        }
        .icon-right {
            width: 0.3rem;
            position: absolute;
            top: 0.5rem;
            right: 0.2rem;
        }
    }
    .issue-detail {
        margin-top: 0.3rem;
        position: relative;
        .detail-title {
            border-bottom: 1px solid $gray-light;
            padding-bottom: 0.3rem;
            padding-right: 0.6rem;
            font-size: 0.3rem;
            margin-bottom: 0.4rem;
        }
        .detail-content {
            font-size: 0.26rem;
        }
        .link-service {
            font-size: 0.26rem;
            color: $gray;
            margin-top: 0.2rem;
            span {
                color: $link-blue;
            }
        }
        .go-back {
            position: absolute;
            top: 0;
            right: 0.2rem;
            .icon-to-left {
                width: 0.3rem;
                color: $gray;
            }
        }
        .evaluate {
            margin-top: 0.6rem;
            text-align: center;
            .agree,
            .disagree {
                display: inline-block;
                width: 48%;
                font-size: 0.22rem;
                background: $bg-gray;
                padding: 0.3rem 0;
                position: relative;
                img {
                    position: absolute;
                    top: 50%;
                    left: 0.5rem;
                    margin-top: -0.24rem;
                }
                &.active {
                    color: $red;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/feedback/index.vue